module.exports = __webpack_public_path__ + "img/products_big_can_cherry.123c5ebe.png";